import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-grow-1 d-flex flex-row token-text-regular" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_radio = _resolveComponent("v-radio")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["radio-list-element d-flex flex-row align-center justify-space-between", { selected: _ctx.selected }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode(_component_v_radio, {
      class: "flex-grow-0",
      color: "rgba(50, 25, 178, 1)",
      disabled: _ctx.disabled,
      modelValue: _ctx.selected
    }, null, 8, ["disabled", "modelValue"])
  ], 2))
}